import { LazyLoad } from 'app/utils';

export const CouponListPage = LazyLoad(
  () => import('./index'),
  (module) => module.CouponListPage,
);
